export default "__VITE_ASSET__36496599__"